import React from "react";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import { routes } from "utilities/routing/generatedRoutes";
import { ShowListWithSales } from "document/linkshow/ShowListWithSales";

interface Props {
  production: server.dto.Tour;
  onFetch: (result: server.dto.ApiResponseWrapperWithRequest<server.dto.ShowForListInternal[], server.dto.ListShowInternalFilters>) => void;
}

const ShowsPanelForProduction = (props: Props) => {
  const artistId = props.production.artists?.length > 0 ? props.production.artists[0].artistId : undefined;
  const artistIdUrl = artistId ? `&artistId=${artistId}` : "";

  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={site.currentEnvironment.show.plural} />
      <PanelSegment.Button onClick={() => {
        window.location.href = `${routes.show_New().absolute}?productionId=${props.production.productionId}${artistIdUrl}`;
      }} label={RESX.Buttons.btnNew} type="secondary" />

    </>}
  >
    <ShowListWithSales
      onFetch={props.onFetch}
      queryKey={[`productionShows-${props.production.productionId}`]}
      perPage={50}
      instruction={{
        productionIds: [props.production.productionId],
      }}
    />
  </SectionPanel.Panel>
};

export default ShowsPanelForProduction;